import {z} from 'zod';

import type {UuidResponseBody} from '@dms/api/shared';

export const mileageConditionSchema = z.object({
  from: z.number().int().nullable(),
  to: z.number().int().nullable(),
});

export type MileageCondition = z.infer<typeof mileageConditionSchema>;

export const conditionRankSchema = z.object({
  conditionId: z.string().uuid(),
  rank: z.number().int(),
});

export type ConditionRank = z.infer<typeof conditionRankSchema>;

export const addInterestAssignmentConditionRequestBodySchema = z.object({
  teamId: z.string().uuid(),
  name: z.string().max(255),
  branchId: z.array(z.string().uuid()),
  make: z.array(z.string()).nullable(),
  model: z.array(z.string()).nullable(),
  modelFamily: z.array(z.string()).nullable(),
  condition: z.array(z.string()).nullable(),
  fuel: z.array(z.string()).nullable(),
  type: z.string().nullable(),
  sourceId: z.array(z.string().uuid()),
  mileage: mileageConditionSchema.nullable(),
});

export type AddInterestAssignmentConditionRequestBody = z.infer<
  typeof addInterestAssignmentConditionRequestBodySchema
>;

export const interestAssignmentConditionResponseBodySchema = z.object({
  id: z.string().uuid(),
  teamId: z.string().uuid(),
  name: z.string(),
  rank: z.number().int(),
  branchId: z.array(z.string().uuid()),
  make: z.array(z.string()).nullable(),
  model: z.array(z.string()).nullable(),
  modelFamily: z.array(z.string()).nullable(),
  condition: z.array(z.string()).nullable(),
  fuel: z.array(z.string()).nullable(),
  type: z.string().nullable(),
  sourceId: z.array(z.string().uuid()),
  mileage: mileageConditionSchema.nullable(),
});

export type InterestAssignmentConditionResponseBody = z.infer<
  typeof interestAssignmentConditionResponseBodySchema
>;

export const assignAssigneeFromTeamRequestBodySchema = z.object({
  teamId: z.string().uuid(),
});

export type AssignAssigneeFromTeamRequestBody = z.infer<
  typeof assignAssigneeFromTeamRequestBodySchema
>;

export const assignOwnerFromTeamRequestBodySchema = z.object({
  teamId: z.string().uuid(),
});

export type AssignOwnerFromTeamRequestBody = z.infer<typeof assignOwnerFromTeamRequestBodySchema>;

export const updateInterestAssignmentConditionRequestBodySchema = z.object({
  teamId: z.string().uuid(),
  name: z.string().max(255),
  branchId: z.array(z.string().uuid()),
  make: z.array(z.string()).nullable(),
  model: z.array(z.string()).nullable(),
  modelFamily: z.array(z.string()).nullable(),
  condition: z.array(z.string()).nullable(),
  fuel: z.array(z.string()).nullable(),
  type: z.string().nullable(),
  sourceId: z.array(z.string().uuid()),
  mileage: mileageConditionSchema.nullable(),
});

export type UpdateInterestAssignmentConditionRequestBody = z.infer<
  typeof updateInterestAssignmentConditionRequestBodySchema
>;

export const reorderConditionsRequestBodySchema = z.object({
  conditions: z.array(conditionRankSchema),
});

export type ReorderConditionsRequestBody = z.infer<typeof reorderConditionsRequestBodySchema>;

export type AddInterestAssignmentConditionApiResponse = UuidResponseBody;

export const listInterestAssignmentConditionsApiArgSchema = z.object({
  teamId: z.string().uuid().nullable(),
});

export type ListInterestAssignmentConditionsApiArg = z.infer<
  typeof listInterestAssignmentConditionsApiArgSchema
>;

export type ListInterestAssignmentConditionsApiResponse = InterestAssignmentConditionResponseBody[];

export const AddInterestAssignmentConditionApiArgSchema = z.object({
  addInterestAssignmentConditionRequestBody: addInterestAssignmentConditionRequestBodySchema,
});

export type AddInterestAssignmentConditionApiArg = z.infer<
  typeof AddInterestAssignmentConditionApiArgSchema
>;

export const removeInterestAssignmentConditionApiArgSchema = z.object({
  conditionId: z.string(),
});

export type RemoveInterestAssignmentConditionApiArg = z.infer<
  typeof removeInterestAssignmentConditionApiArgSchema
>;

export const UpdateInterestAssignmentConditionApiArgSchema = z.object({
  conditionId: z.string().uuid(),
  updateInterestAssignmentConditionRequestBody: updateInterestAssignmentConditionRequestBodySchema,
});

export type UpdateInterestAssignmentConditionApiArg = z.infer<
  typeof UpdateInterestAssignmentConditionApiArgSchema
>;

export const ReorderInterestAssignmentConditionsApiArgSchema = z.object({
  reorderConditionsRequestBody: reorderConditionsRequestBodySchema,
});

export type ReorderInterestAssignmentConditionsApiArg = z.infer<
  typeof ReorderInterestAssignmentConditionsApiArgSchema
>;

export const AssignAssigneeFromTeamApiArgSchema = z.object({
  resourceId: z.string(),
  recordId: z.string(),
  assignAssigneeFromTeamRequestBody: assignAssigneeFromTeamRequestBodySchema,
});

export type AssignAssigneeFromTeamApiArg = z.infer<typeof AssignAssigneeFromTeamApiArgSchema>;

export const AssignOwnerFromTeamApiArgSchema = z.object({
  resourceId: z.string(),
  recordId: z.string(),
  assignOwnerFromTeamRequestBody: assignOwnerFromTeamRequestBodySchema,
});

export type AssignOwnerFromTeamApiArg = z.infer<typeof AssignOwnerFromTeamApiArgSchema>;

export const teamResponseBodySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type TeamResponseBody = z.infer<typeof teamResponseBodySchema>;

export const assigneeTeamListApiArgSchema = z.object({
  resourceId: z.string(),
  recordId: z.string(),
});

export type AssigneeTeamListApiArg = z.infer<typeof assigneeTeamListApiArgSchema>;

export type AssigneeTeamListApiResponse = TeamResponseBody[];

export const ownerTeamListApiArgSchema = z.object({
  resourceId: z.string(),
  recordId: z.string(),
});

export type OwnerTeamListApiArg = z.infer<typeof ownerTeamListApiArgSchema>;

export type OwnerTeamListApiResponse = TeamResponseBody[];
